import * as API from "../../api"
import * as ActionTypes from "../action-types";

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'

import {
    setLoadingLiveTrackLink,
    unsetLoadingLiveTrackLink
} from './style'

/**
 * Get Maintenance Rules
 */

export const get_batch_location_tracking_by_plate_request = (plates = [], cb) => dispatch => {
    dispatch(setLoadingLiveTrackLink())
    API
    .getLocationTrackingBatchByPlates(
        plates
    )
    .then(info => {
        const { links } = info

        dispatch(get_batch_location_tracking_by_plate_success(links))
    })
    .finally(() => {
        cb()
        dispatch(unsetLoadingLiveTrackLink())
    })
}

const get_batch_location_tracking_by_plate_success = (links) => {
    return {
        type: ActionTypes.GET_BATCH_LOCATION_TRACKING,
        links
    }
}


// export const get_location_tracking_request = (uid) => dispatch => {
//     console.log(uid)
//     API
//     .getLocationTrackingThruUID(
//         uid
//     )
//     .then(info => {
//         const { locations } = info

//         dispatch(get_location_tracking_success(locations))
//     })
//     .finally(() => {

//     })
// }

// const get_location_tracking_success = () => {
//     return {
//         type: ActionTypes.GET_LOCATION_TRACKING_THRU_UID
//     }
// }

export const create_live_location_link_request = (items, cb = () => {}) => dispatch => {
    dispatch(setLoadingLiveTrackLink())

    API
    .createLocationTracking(
        items
    )
    // .then(info => {
    //     const { link } = info

    //     dispatch(create_live_location_link_success(link))
    // })
    .finally(() => {
        cb()
        dispatch(unsetLoadingLiveTrackLink())
    })
}

// const create_live_location_link_success = () => {
//     return {
//         type: ActionTypes.CREATE_LOCATION_TRACKING
//     }
// }

export const update_live_location_link_request = (items, cb = () => {}) => dispatch => {
    dispatch(setLoadingLiveTrackLink())
    delete items.detail

    const newitems = {
        trackid: items.trackid,
        plate: items.plate,
        status: items.status,
        startTime: items.startTime,
        endTime: items.endTime,
        desc: items.desc,
        uid: items.uid
    }

    API
    .updateLocationTracking(
        newitems
    )
    .then(info => {
        const { status, msg } = info

        if(status === 200) {
            dispatch(update_live_location_link_success(items))
        } else {
            message.warning('Error when updating live tracking data. Retry? error: ' + msg)
        }
    })
    .finally(() => {
        cb()
        dispatch(unsetLoadingLiveTrackLink())
    })
}

const update_live_location_link_success = (link) => {
    return {
        type: ActionTypes.UPDATE_LOCATION_TRACKING,
        link
    }
}


export const get_tracking_link_by_trackid = (trackid, cb = () => {}) => {
    API
    .getTrackLinkByTRACKID(trackid)
    .then(info => {
        const { status, link = {} } = info

        
        if(status !== 200) {
            message.warning('An Error occured when getting Track Link info. Refresh?')
        } else {
            cb(link)
        }
    })
}

// export const get_batch_vehicle_address_by_vids_request = (items) => dispatch => {
//     console.log(items, dispatch)
// }

export const get_batch_coordinate_address_request = (items, cb = () => {}) => dispatch => {

    items = items.filter(item => item?.lat && item?.lon && item?.vid)

    items.length
    &&
    API
    .getVehicleAddressBatchByVIDS(
        items
    )
    .then(info => {

        const { status, data } = info 

        if(status === 200) {
            dispatch(get_batch_coordinate_address_success(data))
            cb(data)
        } 
        // else {
        //     message.error('Failed in getting addresses.')
        // }
    })
}

export const get_batch_coordinate_address_success = (locations) => {
    return {
        type: ActionTypes.GET_BATCH_COORDINATE_ADDRESS,
        locations
    }
}
